import React from 'react';
import { x } from '@xstyled/styled-components';
import { Item, registry, RenderProps } from '../../Item';
import { LockButton } from '~/ui/buttons/LockButton';
import { TWEET_LOCK } from '../../itemIds';
import { Flex } from '~/ui/flex/Flex';
import { Card } from '~/ui/card/Card';

interface Props {
  text: string;
  width: string;
  height?: string;
}

export class TweetLock extends Item<typeof TWEET_LOCK, Props> {
  protected render({text = '', width = '90%', height, children }: RenderProps<Props>) {
    return (
      <Flex variant="center">
        <Card
          backgroundColor="white"
          w={width}
          h={height}
          minH="220px"
          p={{ _: 'lg', lg: 'xl' }}
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="relative"
        >
          <x.div
            display="flex"
            alignItems="center"
            gap="32px"
            fontSize="23px"
            lineHeight="30px"
            paddingBottom="15px"
          >
            <LockButton number={text} />
            <x.div textTransform="capitalize" color='black'>{children}</x.div>
          </x.div>
        </Card>
      </Flex>
    );
  }
}

registry[TWEET_LOCK] = TweetLock;
